
import { Dialog, DialogContent, Grid, Card, CardHeader, Typography, Divider, CardContent, DialogActions, Button, ListItem, ListItemText, Chip } from "@mui/material";

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle";

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
}

const paquetesFrontend = [
    'React 19.2',
    'TypeScript 4.9',
    'Material UI 7.3',
    'MUI X Date Pickers 8.16',
    'React Router 7.9',
    'Redux Toolkit 2.9',
    'React Redux 9.2',
    'Axios 1.13',
    'Syncfusion Document Editor 27.2',
    'Dynamic Web TWAIN 18.5',
    'Moment 2.30',
    'curp-ts 1.4',
];

const paquetesBackend = [
    '.NET 8',
    'Entity Framework Core 8.0',
    'SQL Server',
    'JWT Bearer 8.0',
    'Syncfusion Word Editor 27.2',
    'Syncfusion DocIO Renderer 27.2',
    'SelectPdf 22.1',
    'ClosedXML 0.105',
    'Newtonsoft.Json 13.0',
    'SendGrid 9.29',
    'Twilio 8.0',
    'Google Cloud Storage 4.13',
];

const serviciosIntegrados = [
    'Expediente virtual',
    'Poder en Línea',
    'RRHH Web',
    'Firma Electrónica',
];

export const DialogAcercaDe = ( { openDialog, handleCloseDialog }: Props ) => {

    return (
        <>

            <Dialog open={ openDialog } fullWidth={true} maxWidth='md' onClose={ handleCloseDialog }>

                <DialogContent sx={ DialogContentStyle }>

                    <Card>
                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del sistema</Typography> }/>

                        <Divider />

                        <CardContent>

                            <Grid container spacing={1}>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ListItem sx={{ px: 0, py: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Nombre: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> SAJI · Mercantil </Typography> }
                                        />

                                    </ListItem>

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ListItem sx={{ px: 0, py: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Versión: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { process.env.REACT_APP_VERSION } </Typography> }
                                        />

                                    </ListItem>

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ListItem sx={{ px: 0, py: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Descripción: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> Sistema de Administración de Justicia Inteligente </Typography> }
                                        />

                                    </ListItem>

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ListItem sx={{ px: 0, py: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Institución: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> Poder Judicial del Estado de Coahuila de Zaragoza </Typography> }
                                        />

                                    </ListItem>

                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Divider sx={{ my: 1 }} />
                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary', mb: 1 }}> Frontend: </Typography>
                                </Grid>

                                {
                                    paquetesFrontend.map( ( paquete, index ) => (

                                        <Grid key={ index } size={{ md: 3, xs: 12 }}>

                                            <Chip
                                                variant="outlined"
                                                color="secondary"
                                                sx={{ py: 2, px: 1, width: '100%' }}
                                                label={ paquete }
                                            />

                                        </Grid>

                                    ))
                                }

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Divider sx={{ my: 1 }} />
                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary', mb: 1 }}> Backend: </Typography>
                                </Grid>

                                {
                                    paquetesBackend.map( ( paquete, index ) => (

                                        <Grid key={ index } size={{ md: 3, xs: 12 }}>

                                            <Chip
                                                variant="outlined"
                                                color="secondary"
                                                sx={{ py: 2, px: 1, width: '100%' }}
                                                label={ paquete }
                                            />

                                        </Grid>

                                    ))
                                }

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Divider sx={{ my: 1 }} />
                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary', mb: 1 }}> Servicios integrados: </Typography>
                                </Grid>

                                {
                                    serviciosIntegrados.map( ( servicio, index ) => (

                                        <Grid key={ index } size={{ md: 3, xs: 12 }}>

                                            <Chip
                                                variant="outlined"
                                                color="secondary"
                                                sx={{ py: 2, px: 1, width: '100%' }}
                                                label={ servicio }
                                            />

                                        </Grid>

                                    ))
                                }

                            </Grid>

                        </CardContent>

                    </Card>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color="secondary" onClick={ handleCloseDialog }>
                        Cerrar
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}
